import { Injectable } from "@angular/core";
import { AlertController, ToastController } from "@ionic/angular";

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private alert: HTMLIonAlertElement;
    constructor(
        private toastController: ToastController,
        private readonly alertCtrl: AlertController,
    ) { }

    async showAlert(
        header: string,
        message: string,
        handlers: { onConfirm: Function; onCancel?: Function } = { onConfirm: () => { } },
        options: { confirmLabel?: string; cancelLabel?: string; confirmOnly?: boolean; cssStyle?: string } = {}
    ) {
        const buttons = options.confirmOnly
            ? [
                {
                    text: options.confirmLabel || 'ตกลง',
                    role: 'confirm',
                    cssClass: "confirm-button",
                    handler: async () => handlers.onConfirm(),
                },
            ]
            : [
                {
                    text: options.cancelLabel || 'ยกเลิก',
                    role: 'cancel',
                    handler: async () => handlers.onCancel?.(),
                },
                {
                    text: options.confirmLabel || 'ยืนยัน',
                    role: 'confirm',
                    cssClass: "confirm-button",
                    handler: async () => handlers.onConfirm(),
                },
            ];

        this.alert = await this.alertCtrl.create({
            header,
            message,
            buttons,
            cssClass: options.cssStyle || 'custom-alert-cancel-confirm',
        });

        this.alert.present();
    }


    async showAlertEditFullName(header: string, name: string, handler: Function) {

        let buttons = [
            {
                text: 'ยกเลิก',
                role: 'cancel',
                handler: async () => {
                },

            }, {
                text: 'ยืนยัน',
                role: 'confirm',
                handler: async (data: any) => {
                    handler(data?.full_name);
                    return true
                },
                cssClass: "confirm-button"

            }
        ]

        this.alert = await this.alertCtrl.create({
            header: header,
            message: '',
            inputs: [
                {
                    name: 'fullName',
                    placeholder: 'Enter your full name',
                    cssClass: 'input-with-label full-name-input',
                    value: name,
                    attributes: {
                        label: 'ชื่อ-นามสกุล'
                    }
                }
            ],
            buttons: buttons,
            cssClass: "inputs-alert"
        });

        this.alert.present();
    }

    async showToast(message: any) {
        const toast = await this.toastController.create({
            message: message,
            duration: 3000, // Adjust the duration as needed
            position: 'top', // Adjust the position as needed
        });
        toast.present();
    }

    async showAlertWithButtonLink(onConfirm: () => Promise<void>) {
        const alert = await this.alertCtrl.create({
            header: 'ระบบขอยืนยันตัวตนด้วย ThaiD',
            message: 'ระบบจะทำการเปิด tab ใหม่เพื่อให้คุณยืนยันตัวตนผ่าน Application ThaiD เพื่อยืนยันกระบวนการใช้งาน',
            cssClass: 'thaid-alert',
            buttons: [
                {
                    text: 'เปิด ThaiD',
                    cssClass: 'thaid-alert-button',
                    handler: async () => {
                        await onConfirm();
                        // window.location.href = url;
                        // window.open(url, '_blank', 'noopener,noreferrer');
                    },
                },
            ],
        });
        await alert.present();
    }

    async showRetryLoadContent(handler: Function) {
        const alert = await this.alertCtrl.create({
            header: 'เกิดข้อผิดพลาด',
            message: 'ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
            backdropDismiss: false,
            cssClass: 'custom-alert-cancel-confirm',
            buttons: [
                {
                    text: 'ย้อนกลับ',
                    role: 'cancel',
                },
                {
                    text: 'รับทราบ',
                    handler: async () => {
                        handler();
                    },
                },
            ],
        });

        await alert.present();
    };



}

